import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  paginatedNewsRequest,
  newsByTagsRequest,
  getLatestNews as getLatestNewsReducer,
  getNewsCount as getNewsCountReducer,
  getPaginatedNewsSearch as getPaginatedNewsReducerSearch,
  getPaginatedNewsLoadMore as getPaginatedNewsLoadMoreReducer,
  getNewsCategories as getNewsCategoriesReducer,
  getNewsTags as getNewsTagsReducer,
  getNewsDetails as getNewsDetailsReducer,
  getNewsByTags as getNewsByTagsReducer,
  clearNewsDetails as clearNewsDetailsReducer,
  clearNewsByTags as clearNewsByTagsReducer,
} from 'reducers/news.reducer'
import { newsService } from 'services/news.service'

export const getLatestNews = () => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await newsService.getLatestNews()
    if (response) {
      const latestNewsData = response

      dispatch(getLatestNewsReducer({ latestNewsData }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const getNewsCount =
  (searchTerm: string, categoryId: string, tagId: string, isAr: boolean) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(paginatedNewsRequest())

      const response = await newsService.getNewsCount(
        searchTerm,
        categoryId,
        tagId,
        isAr
      )
      if (response) {
        const newsCount = response

        dispatch(getNewsCountReducer({ newsCount }))
      }
    } catch (error) {
      console.error(error)
      dispatch(apiFailure())
    }
  }

export const getPaginatedNews =
  (
    from: number,
    to: number,
    searchTerm: string,
    categoryId: string,
    tagId: string,
    isAr: boolean
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(paginatedNewsRequest())

      const response = await newsService.getPaginatedNews(
        from,
        to,
        searchTerm,
        categoryId,
        tagId,
        isAr
      )
      if (response) {
        const paginatedNews = response

        if (from === 0)
          dispatch(getPaginatedNewsReducerSearch({ paginatedNews }))
        else dispatch(getPaginatedNewsLoadMoreReducer({ paginatedNews }))
      }
    } catch (error) {
      console.error(error)
      dispatch(apiFailure())
    }
  }

export const getNewsTags = () => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await newsService.getNewsTags()
    if (response) {
      const newsTags = response

      dispatch(getNewsTagsReducer({ newsTags }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const getNewsCategories = () => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await newsService.getNewsCategories()
    if (response) {
      const newsCategories = response

      dispatch(getNewsCategoriesReducer({ newsCategories }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const getNewsDetails = (slug: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await newsService.getNewsDetails(slug)
    if (response) {
      const newsDetails = response

      dispatch(getNewsDetailsReducer({ newsDetails }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const getNewsByTags = (tags: string[]) => async (dispatch: Dispatch) => {
  try {
    dispatch(newsByTagsRequest())

    const response = await newsService.getNewsByTags(tags)
    if (response) {
      const newsByTags = response

      dispatch(getNewsByTagsReducer({ newsByTags }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const clearNewsDetails = () => (dispatch: Dispatch) => {
  try {
    dispatch(clearNewsDetailsReducer())
  } catch (error) {
    console.error(`Could not clear news details state: ${error}`)
  }
}

export const clearNewsByTags = () => (dispatch: Dispatch) => {
  try {
    dispatch(clearNewsByTagsReducer())
  } catch (error) {
    console.error(`Could not clear news by tags state: ${error}`)
  }
}
